
const digest = 'f46f4dc9ed8ad715c7e89f8fa3fd6e76d8345ed784666491544b43deffc38071';
const classes = {"items":"_items_1q9c4_1"};
const css = `._items_1q9c4_1 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: -1px;
  z-index: 1;
  position: relative;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  